import React from 'react'
import HorizontalBar from './HorizontalBar'

export interface BarItem {
    label?: string
    value: number
}

interface HorizontalBarChartProps {
    data: BarItem[]
    barHeight?: number
    maxWidth?: number
    labelWidth?: number
    formatValue?: (value: number) => string
}

const HorizontalBarChart = ({
    data,
    barHeight = 20,
    maxWidth = 200,
    labelWidth = 130,
    formatValue,
}: HorizontalBarChartProps) => {
    const maxValue = Math.max(...data.map((item) => item.value), 1)

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {data.map((item, index) => (
                <HorizontalBar
                    key={index}
                    value={item.value}
                    maxValue={maxValue}
                    label={item.label}
                    barHeight={barHeight}
                    maxWidth={maxWidth}
                    labelWidth={labelWidth}
                    formatValue={formatValue}
                />
            ))}
        </div>
    )
}

export default HorizontalBarChart
